import styled, { css } from "styled-components";

import { $dmSansFontFamily, colorsPalettes } from "@similarweb/styles";

import { FilterButtonVariant } from "./FilterButton.types";

export const StyledFilterButton = styled.button<{ variant: FilterButtonVariant }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-width: 70px;
    width: auto;
    height: 32px;
    padding: 0 12px;
    color: ${colorsPalettes.carbon[500]};
    font-family: ${$dmSansFontFamily};
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    border: 1px solid ${colorsPalettes.carbon[100]};
    border-radius: 40px;
    background-color: ${colorsPalettes.carbon[0]};
    transition: background-color 0.2s ease-in-out;

    &:hover,
    &:active {
        background-color: ${colorsPalettes.blue[50]};
    }

    ${({ variant }) => {
        switch (variant) {
            case FilterButtonVariant.disabled:
                return css`
                    color: ${colorsPalettes.carbon[200]};
                    background-color: ${colorsPalettes.carbon[0]};
                    cursor: not-allowed;

                    &:hover,
                    &:active {
                        background-color: ${colorsPalettes.carbon[0]};
                    }
                `;
            case FilterButtonVariant.selected:
                return css`
                    background-color: ${colorsPalettes.blue[100]};
                    border-color: ${colorsPalettes.blue[100]};
                    color: ${colorsPalettes.blue[400]};
                `;
            case FilterButtonVariant.dashed:
                return css`
                    border-color: ${colorsPalettes.blue[400]};
                    border-style: dashed;
                    color: ${colorsPalettes.blue[400]};

                    &:hover,
                    &:active {
                        background-color: ${colorsPalettes.blue[50]};
                    }
                `;
        }
    }}
`;
